import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'grid grid-cols-1 gap-x-20 gap-y-1.5 md:grid-cols-2 md:gap-y-2.5',
    label: 'heading-sm md:heading-m md:tracking-[0.05px]',
    value: 'heading-sm md:heading-s text-right md:tracking-[0.05px]'
  }
});
